export const LOAD_CATEGORYCAROUSEL_DATA = 'categoryCarousel/LOAD_CATEGORYCAROUSEL_DATA';
export const SUCCESS_CATEGORYCAROUSEL_DATA = 'categoryCarousel/SUCCESS_CATEGORYCAROUSEL_DATA';
export const FAILURE_CATEGORYCAROUSEL_DATA = 'categoryCarousel/FAILURE_CATEGORYCAROUSEL_DATA';

